// This file contains mappings between fixed API values and whatever we use
// in the frontend application

export const realEstateTypes = ['appartment', 'house']

export const analyseSteps = [
  {
    name: 'allocation',
    substeps: 5,
    helps: [
      null,
      [ 'analyse.allocation.helps.profile' ],
      [
        'analyse.allocation.helps.strategy[0]',
        'analyse.allocation.helps.strategy[1]',
        'analyse.allocation.helps.strategy[2]'
      ]
    ]
  },
  {
    name: 'performances',
    substeps: 5,
    hideSteps: [4],
    helps: [
      null,
      ['analyse.performances.helps.passed'],
      ['analyse.performances.helps.funds']
    ]
  },
  {
    name: 'risk',
    substeps: 5,
    helps: [
      null,
      ['analyse.risk.helps.allocation']
    ]
  },
  {
    name: 'fees',
    substeps: 5,
    helps: [
      null,
      ['analyse.fees.helps.contract'],
      ['analyse.fees.helps.funds'],
      ['analyse.fees.helps.total']
    ]
  },
  {
    name: 'advices',
    substeps: 3
  }
]

export const budgetInsightErrors = {
  authFailed: 'auth_failed',
  bug: 'bug',
  needAction: 'actionNeeded',
  needAdditional: 'additionalInformationNeeded',
  none: 'none',
  scrappingFailed: 'scrapping_failed',
  websiteUnavailable: 'websiteUnavailable',
  wrongpass: 'wrongPass'
}

export const investmentKinds = [
  'saving_precautionary',
  'capital_increase',
  'pension',
  'real_estate',
  'transmission',
  'future_children',
  'other'
]

export const feesList = [
  'entryFee',
  'exitFee',
  'depositFee',
  'euroFundsFees',
  'ucsFee',
  'managementFee'
]

export const feesSpecialList = [
  'entryFee',
  'exitFee',
  'depositFee',
  'ucsFee',
  'managementFee',
  'transferFee'
]

export const notificationKinds = [
  'portfolio',
  'system',
  'account',
  'profile',
  'connection'
]
